import * as yup from 'yup';

export const hoaFormValidator = () =>
  yup.object({
    nameOfHoa: yup.string().nullable(),
    managementCompany: yup.string().nullable(),
    primaryContactName: yup.string().nullable(),
    primaryContactEmail: yup.string().email().nullable(),
    primaryContactPhone: yup.string().nullable(),
  });
